import { Component, HostBinding, Input } from '@angular/core';
import { Task } from '@brafton/angular-framework-library';
import { Observable } from 'rxjs';

@Component({
  selector: 'shared-paging-button',
  templateUrl: './paging-button.component.html',
  styleUrls: ['./paging-button.component.scss'],
  host: { class: 'paging-button' },
})
export class SharedPagingButtonComponent {
  @Input() task!: Task;
  @Input() loading!: Observable<boolean>;
  @Input() accentColour: 'green' | 'yellow' | 'blue' | 'gray' | 'turquoise' = 'green';
  @HostBinding('class') get currentAccentColour() {
    return this.accentColour;
  }

  constructor() {}
}
